var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-content',[_c('div',{staticClass:"scroll-container"},[_vm._t("default")],2)]),_c('notification-snackbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }